import config from 'config';
import {getWidgetValue, byMatching} from "sportinglife-react-common/widgets";

const LOAD = 'horse-racing/rides/LOAD';
const LOAD_SUCCESS = 'horse-racing/rides/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/rides/LOAD_FAIL';

const initialState = {
  races: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      const mergedRaces = state.races ? [...state.races, ...action.result] : action.result;

      return {
        ...state,
        races: mergedRaces,
        loading: false,
        loaded: true,
        error: null
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function loadRides(idList) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(config.api.horseRacing.loadRace, {params: {ride_ids: idList.join(",")}})
  };
}

export function loadRidesForArticle(globalState, dispatch, article) {
  const idList = article.widgets
    .filter(byMatching({type: "Racerunner"}))
    .map(widget => getWidgetValue(widget, "ride_id"));

  if (idList.length) {
    return dispatch(loadRides(idList));
  }

  return Promise.resolve();
}




// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/rides.js